import { addCadrageToVentilatedData } from 'routes/BudgetModule/helpers/dataOperation';

import { BudgetProposalT } from 'routes/BudgetModule/config/types';
import { useContext } from 'react';
import { getBudgetVentilatedQuery } from 'routes/BudgetModule/helpers/query';
import { UseQueryOptions } from '@tanstack/react-query';
import { useGetCadrageData } from './getCadrageData';
import { useGetBudgetVentilatedData } from '../../Resource/hooks/budgetProposal';
import { StatusSettingsContext } from 'routes/BudgetModule/components/BudgetWithProvider/StatusSettingsContext';

const useGetBudgetVentilatedDataByResource = ({
    budgetProposal,
    enabled = true,
    budgetLineCode = undefined,
}: {
    budgetProposal: BudgetProposalT;
    enabled: UseQueryOptions['enabled'];
    budgetLineCode?: string;
}) => {
    const {
        data: budgetVentilatedData,
        isLoading: isBudgetVentilatedDataLoading,
        error,
        isError,
    } = useGetBudgetVentilatedData({
        budgetProposalId: budgetProposal.id,
        exercice: budgetProposal.exercice,
        budgetLineCode: budgetLineCode,
        params: { enabled },
    });

    const cadrageQueryResult = useGetCadrageData(
        budgetProposal,
        budgetLineCode,
        {
            enabled: enabled,
        },
    );
    const cadrageData = cadrageQueryResult.isSuccess
        ? cadrageQueryResult.data
        : [];

    const mergedData =
        !!budgetVentilatedData && !!cadrageData && enabled
            ? addCadrageToVentilatedData(
                  budgetVentilatedData,
                  cadrageData,
                  budgetProposal.by,
              )
            : undefined;

    return {
        data: mergedData,
        isLoading:
            isBudgetVentilatedDataLoading || cadrageQueryResult.isLoading,
        error,
        isError,
    };
};

type BudgetVentilatedByResourceT = {
    budgetProposal: BudgetProposalT;
    enabled?: UseQueryOptions['enabled'];
    budgetLineCode?: string;
    extraFilters?: QueryFilterT[];
};

export const useGetBudgetVentilatedByResource = ({
    budgetProposal,
    enabled = true,
    budgetLineCode = undefined,
    extraFilters = [],
}: BudgetVentilatedByResourceT) => {
    const statusesSettings = useContext(StatusSettingsContext);

    const budgetVentilatedQuery = getBudgetVentilatedQuery(
        budgetProposal,
        'resource',
        statusesSettings,
        extraFilters,
    );

    const { data, isLoading, error, isError } =
        useGetBudgetVentilatedDataByResource({
            budgetProposal,
            enabled,
            budgetLineCode,
        });

    return {
        data,
        isLoading: isLoading,
        query: budgetVentilatedQuery,
        error,
        isError,
    };
};
